<template>
  <div class="evaluate" id="evaluate">
    <!-- 条件查询 -->
    <div class="evaluate_search" id="search">
      <el-form :model="searchForm" label-width="85px" :inline="true">
        <el-form-item label="医生姓名：">
          <el-select v-model="searchForm.doctorId" class="evaluate_search_input" placeholder="" filterable
            default-first-option allow-create clearable>
            <el-option v-for="item in doctorOptions" :key="item.doctorId" :label="item.label" :value="item.doctorId">
              <span class="fl">{{ item.label }}</span>
              <span class="select-flex">{{ item.phone }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生评价：">
          <el-select v-model="searchForm.efficacyEvaluation" class="evaluate_search_input" placeholder="" clearable>
            <el-option v-for="item in starLevelList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医馆服务：">
          <el-select v-model="searchForm.starLevel" class="evaluate_search_input" placeholder="" clearable>
            <el-option v-for="item in starLevelList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医馆环境：">
          <el-select v-model="searchForm.clinicEnvironment" class="evaluate_search_input" placeholder="" clearable>
            <el-option v-for="item in starLevelList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐指数：">
          <el-select v-model="searchForm.recommendationIndex" class="evaluate_search_input" placeholder="" clearable>
            <el-option v-for="item in recommendationIndexList" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回复状态：">
          <el-select v-model="searchForm.replyStatus" class="evaluate_search_input" placeholder="" clearable>
            <el-option label="已回" value="1" />
            <el-option label="未回" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="隐藏状态：">
          <el-select v-model="searchForm.showStatus" class="evaluate_search_input" placeholder="" clearable>
            <el-option label="未隐藏" value="0" />
            <el-option label="已隐藏" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="评价时间：">
          <el-date-picker v-model="searchDate" class="evaluate_search_input" range-separator="至" type="daterange"
            placeholder="" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="评价类型：">
          <el-select v-model="searchForm.evaType" class="evaluate_search_input" placeholder="" clearable>
            <el-option label="患者评价" :value="1" />
            <el-option label="平台导入" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label-width="0px">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="primary" plain  @click="importDoctorEvaluate">导入医生评价</el-button>
          <el-button @click="handleExport">导出</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

    </div>
    <!-- 评价列表 -->
    <div ref="evaluateTableWrap" class="evaluate_table">
      <el-table v-loading="loading" :data="list" border :height="tableHeight"
        tooltip-effect="dark evaluate_table_tooltips">
        <el-table-column fixed type="index" :index="indexMethod" label="序号" width="50"></el-table-column>
        <el-table-column fixed prop="doctorName" label="被评价医生" width="100"></el-table-column>
        <el-table-column prop="sysMember.memberName" label="患者姓名" width="100"></el-table-column>
        <el-table-column prop="sysMember.phone" label="联系电话" width="130"></el-table-column>
        <el-table-column prop="deptName" label="就诊医馆" width="100"></el-table-column>
        <el-table-column prop="orderNumber" label="门诊单号" width="180"></el-table-column>
        <el-table-column label="医生评价" width="300">
          <template slot-scope="scope">
            <div>
              <el-rate v-model="scope.row.efficacyEvaluation" disabled show-text
                :texts="Object.values(starLevelMap)">
              </el-rate>
            </div>
            <div>
              <span>{{ scope.row.efficacyEvaluationContent }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="医馆服务" width="300">
          <template slot-scope="scope">
            <div>
              <el-rate v-model="scope.row.starLevel" disabled show-text :texts="Object.values(starLevelMap)">
              </el-rate>
            </div>
            <div>
              <span>{{ scope.row.starLevelContent }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="医馆环境" width="300">
          <template slot-scope="scope">
            <div>
              <el-rate v-model="scope.row.clinicEnvironment" disabled show-text :texts="Object.values(starLevelMap)">
              </el-rate>
            </div>
            <div>
              <span>{{ scope.row.clinicEnvironmentContent }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="推荐指数" width="210">
          <template slot-scope="scope">
            <el-rate v-model="scope.row.recommendationIndex" disabled show-text
              :texts="Object.values(recommendationIndexMap)">
            </el-rate>
          </template>
        </el-table-column>
        <el-table-column prop="evaluationContent" label="改进建议" width="300" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="评价日期" width="160"></el-table-column>
        <el-table-column label="回复状态" width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.replyStatus === '0' ? '未回' : '已回' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="replyContent" label="回复内容" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="隐藏状态" width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.showStatus === '0' ? '未隐藏' : '已隐藏' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="toReply(scope.row)">回复</el-button>
            <el-button :icon="scope.row.showStatus === '0' ? 'el-icon-circle-close' : 'el-icon-circle-check'"
              :type="scope.row.showStatus === '0' ? 'danger' : 'success'" @click="showStatusChange(scope.row)">{{
                scope.row.showStatus === '0' ? '隐藏' : '显示' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="evaluate_pagination" id="pagination">
      <el-pagination :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="total" @current-change="pageNoChange">
      </el-pagination>
    </div>
    <!-- 导入医生评价弹框 -->
    <el-dialog
      class="evaluate-import-dialog"
      title="导入医生评价"
      :visible.sync="importDialogVisible"
      width="435px"
      :close-on-click-modal="false"
      @close="resetImportDialog">
      <div class="evaluate-import-content">
        <div class="evaluate-import-template" @click="downloadImportTemplate">下载导入模板</div>
        <div class="evaluate-import-row">
          <span class="evaluate-import-label">请上传Excel文件</span>
          <el-upload
            ref="doctorEvaluateUpload"
            class="evaluate-import-upload"
            action=""
            accept=".xls,.xlsx"
            :auto-upload="false"
            :show-file-list="true"
            :file-list="importFileList"
            :limit="1"
            :on-change="handleImportFileChange"
            :on-remove="handleImportFileRemove"
            :on-exceed="handleImportFileExceed">
            <el-button class="evaluate-import-select" plain>+选择文件</el-button>
          </el-upload>
        </div>
        <div class="evaluate-import-footer">
          <el-button type="primary" :loading="importLoading" @click="confirmImportDoctorEvaluate">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 回复弹框 -->
    <el-dialog class="dialogEdit reply" title="回复用户" :visible.sync="dialogVisible" width="540px"
      :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
      <div class="reply_form">
        <div class="form_item">
          <div class="reply_label">患者姓名：</div>
          <div class="reply_value">{{ editForm.sysMember && editForm.sysMember.memberName || '' }} {{ editForm.sysMember
            &&
            editForm.sysMember.phone || '' }}</div>
        </div>
        <div class="form_item">
          <div class="reply_label">就诊医馆：</div>
          <div class="reply_value">{{ editForm.deptName || '' }}</div>
        </div>
        <div class="form_item">
          <div class="reply_label">评价医生：</div>
          <div class="reply_value">{{ editForm.doctorName || '' }}</div>
        </div>
        <div class="form_item">
          <div class="reply_label">医生评价：</div>
          <div class="reply_value">
            <el-rate v-model="editForm.efficacyEvaluation" disabled show-text
              :texts="Object.values(efficacyEvaluationMap)"></el-rate>
          </div>
        </div>
        <div class="form_item_detail" v-if="editForm.efficacyEvaluationContent">{{ editForm.efficacyEvaluationContent }}
        </div>
        <div class="form_item">
          <div class="reply_label">医馆服务：</div>
          <div class="reply_value">
            <el-rate v-model="editForm.starLevel" disabled show-text :texts="Object.values(starLevelMap)"></el-rate>
          </div>
        </div>
        <div class="form_item_detail" v-if="editForm.starLevelContent">{{ editForm.starLevelContent }}</div>
        <div class="form_item">
          <div class="reply_label">推荐指数：</div>
          <div class="reply_value">
            <el-rate v-model="editForm.recommendationIndex" disabled show-text
              :texts="Object.values(recommendationIndexMap)"></el-rate>
          </div>
        </div>
        <div class="reply_label mb6">改进建议：</div>
        <div class="form_item_detail" v-if="editForm.evaluationContent">{{ editForm.evaluationContent || '' }}</div>
        <div class="reply_line"></div>
        <div class="form_item">
          <div class="reply_label">回复人员：</div>
          <div class="reply_value">{{ editForm.updateBy || '' }}</div>
        </div>
        <div class="reply_label">回复内容：</div>
        <el-input type="textarea" placeholder="请输入回复内容" class="reply_textarea" show-word-limit
          v-model="editForm.replyContent" :autosize="{ minRows: 3, maxRows: 6 }" maxlength="500" resize="none" />
      </div>
      <!-- 操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        <el-button type="primary" @click="replay">提交回复</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script lang="js">
import { starLevelMap, efficacyEvaluationMap, recommendationIndexMap } from '@/utils/config_evaluate.js'
import { evaluateList, evaluateHide, evaluateReply, evaluateExport, evaluateImportTemplate, evaluateImport } from "@/api/evaluate"; // 评价请求
import { debounce } from '@/utils/validateBase.js'
import { Utils } from '@/utils/utils'
export default {
  name: "Evaluate",
  data() {
    return {
      doctorOptions: [],
      starLevelMap: starLevelMap,
      efficacyEvaluationMap: efficacyEvaluationMap,
      recommendationIndexMap: recommendationIndexMap,
      loading: true,
      searchDate: [Utils.timeFormat(Number(Utils.startOfDay(this.$moment().startOf('month'))), 'yyyy-MM-DD'), Utils.timeFormat(Number(Utils.endOfDay(this.$moment().endOf('month'))), 'yyyy-MM-DD')],
      searchForm: {
        deptId: sessionStorage.getItem('deptId') === '0' ? '' : sessionStorage.getItem('deptId'),
        doctorId: '',
        starLevel: '',
        efficacyEvaluation: '',
        recommendationIndex: '',
        replyStatus: '',
        showStatus: '',
        clinicEnvironment: '',
        evaType: '',
      },
      tableHeight: 400,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dialogVisible: false,
      editForm: {},
      importDialogVisible: false,
      importLoading: false,
      importFile: null,
      importFileList: [],
    }
  },
  computed: {
    starLevelList() {
      return Object.keys(starLevelMap).map(key => {
        return {
          label: starLevelMap[key],
          value: Number(key)
        }
      })
    },
    efficacyEvaluationList() {
      return Object.keys(efficacyEvaluationMap).map(key => {
        return {
          label: efficacyEvaluationMap[key],
          value: Number(key)
        }
      })
    },
    recommendationIndexList() {
      return Object.keys(recommendationIndexMap).map(key => {
        return {
          label: recommendationIndexMap[key],
          value: Number(key)
        }
      })
    }
  },
  created() {
    this.getEvaluateList();// 获取评价列表
    this.$getDoctorOptions({ appStatus: 0 }); // 所有公众号展示医生
  },
  mounted() {
    this.$nextTick(() => {
      this.resizeTableHeight();
    })
    window.addEventListener('resize', this.resizeTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeTableHeight);
  },
  methods: {
    resizeTableHeight() {
      this.$nextTick(() => {
        const tableWrap = this.$refs.evaluateTableWrap;
        if (tableWrap && tableWrap.clientHeight) {
          this.tableHeight = tableWrap.clientHeight;
          return;
        }
        const evaluate = document.getElementById('evaluate');
        const search = document.getElementById('search');
        const pagination = document.getElementById('pagination');
        const evaluateHeight = evaluate ? evaluate.clientHeight : 0;
        const searchHeight = search ? search.clientHeight : 0;
        const paginationHeight = pagination ? pagination.clientHeight : 0;
        this.tableHeight = Math.max(evaluateHeight - searchHeight - paginationHeight - 40, 240);
      })
    },
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1;
    },
    // 获取评价列表
    async getEvaluateList() {
      this.searchDate = this.searchDate || []
      let params = {
        ...this.searchForm,
        startTimeNew: this.searchDate[0] || '',
        endTimeNew: this.searchDate[1] || '',
        pageNum: this.pageNo,
        pageSize: this.pageSize
      };
      this.loading = true;
      let { total, rows, code } = await evaluateList(params);
      if (code == 200) {
        this.total = total;
        this.list = rows;
        this.resizeTableHeight();
      }
      this.loading = false;
    },
    // 查询
    search() {
      this.pageNo = 1;
      this.getEvaluateList();
    },
    // 重置
    reset() {
      this.searchForm = {
        deptId: sessionStorage.getItem('deptId') === '0' ? '' : sessionStorage.getItem('deptId'),
        doctorId: '',
        starLevel: '',
        efficacyEvaluation: '',
        recommendationIndex: '',
        replyStatus: '',
        showStatus: '',
        clinicEnvironment: '',
        evaType: '',
      };
      this.searchDate = [Utils.timeFormat(Number(Utils.startOfDay(this.$moment().startOf('month'))), 'yyyy-MM-DD'), Utils.timeFormat(Number(Utils.endOfDay(this.$moment().endOf('month'))), 'yyyy-MM-DD')]
      this.pageNo = 1;
      this.getEvaluateList();
    },
    pageNoChange(num) {
      this.pageNo = num;
      this.getEvaluateList();
    },
    importDoctorEvaluate() {
      this.importDialogVisible = true;
    },
    downloadImportTemplate() {
      evaluateImportTemplate({ name: '医生评价导入模板' }).then(() => {
        this.$message.success('下载成功');
      })
    },
    resetImportDialog() {
      this.importFile = null;
      this.importFileList = [];
      this.importLoading = false;
      if (this.$refs.doctorEvaluateUpload) {
        this.$refs.doctorEvaluateUpload.clearFiles();
      }
    },
    handleImportFileChange(file) {
      const rawFile = file.raw || file;
      const fileName = rawFile.name || file.name || '';
      const isExcel = /\.(xls|xlsx)$/i.test(fileName);
      if (!isExcel) {
        this.importFile = null;
        this.importFileList = [];
        if (this.$refs.doctorEvaluateUpload) {
          this.$refs.doctorEvaluateUpload.clearFiles();
        }
        return this.$message.error('请上传Excel文件');
      }
      this.importFile = rawFile;
      this.importFileList = [file];
    },
    handleImportFileRemove() {
      this.importFile = null;
      this.importFileList = [];
    },
    handleImportFileExceed() {
      this.$message.warning('只能上传一个Excel文件');
    },
    formatImportError(item) {
      if (typeof item === 'string') return item;
      const row = item.row || item.rowNum || item.rowIndex || '';
      const col = item.col || item.column || item.columnNum || item.columnIndex || '';
      const error = item.error || item.message || item.msg || '格式错误';
      if (row && col) return `第${row}行第${col}列${error}，请修改后重新导入`;
      if (row) return `第${row}行${error}，请修改后重新导入`;
      return `${error}，请修改后重新导入`;
    },
    async confirmImportDoctorEvaluate() {
      if (!this.importFile) return this.$message.error('请先选择Excel文件');
      const formData = new FormData();
      formData.append('file', this.importFile);
      formData.append('deptId', sessionStorage.getItem('deptId') === '0' ? '' : sessionStorage.getItem('deptId'));
      this.importLoading = true;
      try {
        const res = await evaluateImport(formData);
        if (res.code == 200) {
          this.$message.success('导入成功');
          this.importDialogVisible = false;
          this.getEvaluateList();
        }
      } finally {
        this.importLoading = false;
      }
    },
    // 去回复
    toReply(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editForm.updateBy = this.$session.get("user").nickName;
      this.dialogVisible = true;
    },
    // 回复
    replay() {
      if (!this.editForm.replyContent) return this.$message.error("请输入回复内容！");
      evaluateReply({
        evaluationId: this.editForm.evaluationId,
        replyStatus: '1',
        replyContent: this.editForm.replyContent
      }).then(res => {
        let { code } = res;
        if (code == 200) this.$message.success("回复成功！");
        this.dialogVisible = false;
        this.getEvaluateList();
      })
    },
    // 隐藏评价
    async showStatusChange(row) {
      let { code } = await evaluateHide({
        evaluationId: row.evaluationId,
        showStatus: row.showStatus === '0' ? '1' : '0'
      });
      if (code == 200) {
        this.$message.success("处理成功！");
      }
      this.getEvaluateList();
    },
    //导出
    handleExport: debounce(function () {
      this.searchDate = this.searchDate || []
      let params = {
        ...this.searchForm,
        startTimeNew: this.searchDate[0] || '',
        endTimeNew: this.searchDate[1] || '',
        pageNum: this.pageNo,
        pageSize: this.pageSize
      };
      evaluateExport(params, { name: '评价列表' }).then(res => { })
    }, 1000, true),
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding-top: 16px;
}

/deep/.el-date-editor .el-range__close-icon {
  line-height: 24px;
}

.evaluate {
  box-sizing: border-box;
  padding: 20px;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.evaluate_search {
  overflow: hidden;
}

.evaluate_search /deep/ .el-row:not(:first-child) {
  margin-top: 10px;
}

.evaluate_search /deep/ .el-form-item__label,
.evaluate_search /deep/ .el-form-item__content {
  line-height: 32px;
}

.evaluate_search_input {
  width: 100%;
  height: 32px;
}

.evaluate_pagination {
  flex: none;
  margin: 20px 0 0 0;
}

.evaluate-import-content {
  padding: 8px 0 0;
}

.evaluate-import-template {
  display: inline-block;
  margin-bottom: 16px;
  color: #3974df;
  cursor: pointer;
}

.evaluate-import-row {
  display: flex;
  align-items: flex-start;
}

.evaluate-import-label {
  flex-shrink: 0;
  margin-right: 20px;
  color: #1f2329;
  font-size: 14px;
  line-height: 32px;
}

.evaluate-import-upload {
  flex: 1;
}

.evaluate-import-select {
  color: #3f6ff5;
  border-color: #3f6ff5;
}

.evaluate-import-footer {
  margin-top: 42px;
  text-align: right;
}

.evaluate-import-footer /deep/ .el-button {
  min-width: 100px;
}

.reply_form {
  height: 500px;
  overflow: auto;
}

.form_item_detail {
  padding: 6px;
  background: #F7F8F9;
  color: #667182;
  font-size: 12px;
  line-height: 18px;
  border: 1px solid #E0E0E0;
  margin-bottom: 6px;
}

.form_item {
  font-size: 14px;
  align-items: center;
  display: flex;
  margin-bottom: 6px;
}

.reply_label {
  flex-grow: 0;
  flex-shrink: 0;
  color: #667182;
}

.reply_line {
  border: 1px dashed #E0E0E0;
  margin-top: 16px;
  margin-bottom: 16px;
}

.reply_textarea {
  font-size: 14px;
  color: #A4AFBA;
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  margin-top: 6px;
  box-sizing: border-box;

  /deep/.el-textarea__inner {
    font-size: 14px;
    color: #667182;
  }

}

.reply_form /deep/ .el-form-item {
  display: flex;
  width: 100%;
}

.reply_form /deep/ .el-form-item__label {
  flex-shrink: 0;
}

.reply_form /deep/ .el-form-item__content {
  margin: 0 0 0 0 !important;
  flex-grow: 1;
}

.reply_value {
  width: 100%;
  overflow: hidden;
  color: #000;
}
</style>

<style lang="less">
.evaluate_table_tooltips {
  max-width: 400px;
}

.evaluate-import-message {
  width: 435px;
}

.evaluate-import-message .el-message-box__header {
  padding: 12px 16px;
}

.evaluate-import-message .el-message-box__content {
  padding: 28px 54px 24px;
  color: #1f2329;
  font-size: 14px;
  line-height: 22px;
}

.evaluate-import-message .el-message-box__btns {
  padding: 10px 18px 22px;
}

.evaluate-import-message .el-message-box__btns .el-button {
  min-width: 100px;
}
.evaluate_table{
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
}

.evaluate_table /deep/ .el-table {
  flex: 1;
}

.evaluate_pagination {
  flex: none;
  margin: 20px 0 0 0;
}
</style>
